export default "__VITE_ASSET__9a109034__"